export default "/_next/static/videos/mockup_fb.mp4";